import { Skeleton } from "~/react/ui/skeleton"

type Props = {
  previewContent: string
}

export default function SignaturePreviewContent({ previewContent }: Props) {
  return (
    <div className="signature-preview">
      <div className="signature-preview__content">
        <div className="signature-preview__skeleton">
          <Skeleton
            size="freeform"
            style={{ width: "80%", height: "0.8rem", marginBottom: "0.8rem" }}
          />
          <Skeleton
            size="freeform"
            style={{ width: "60%", height: "0.8rem", marginBottom: "0.8rem" }}
          />
          <Skeleton
            size="freeform"
            style={{ width: "70%", height: "0.8rem", marginBottom: "1.6rem" }}
          />
          <Skeleton
            size="freeform"
            style={{ width: "80%", height: "0.8rem", marginBottom: "0.8rem" }}
          />
          <Skeleton
            size="freeform"
            style={{ width: "60%", height: "0.8rem" }}
          />
        </div>

        {previewContent ? (
          <div
            className="signature-preview__signature"
            dangerouslySetInnerHTML={{ __html: previewContent }}
          />
        ) : (
          <div className="signature-preview__signature signature-preview__signature--empty">
            {i18n.t("js.email_accounts.accounts.no_signature_preview")}
          </div>
        )}
      </div>
    </div>
  )
}
